/* ****************************** Import Packages ***************************** */
import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Max_Logo from "../../assets/images/ScribeSmart.png";
// import MinimizerIcon from "../../assets/icons/minizer.png";
import MinimizerIcon from "../../assets/icons/arrow-side-bar.svg";

/* ****************************** Import Images ***************************** */
// import Logo from "../../assets/images/group.svg";

import { SlArrowDown } from "react-icons/sl";

const Sidebar = (props:any) => {
  const {
    Routes,
    sidebarState,
    handleEvent,
    arrow,
    handleArrow,
    scrollActive,
    profileDropdownClose,
    handleSidebarMinimize,
  } = props;

  const [childerenActive, setChilderenActive] = useState(false);
  const [clickedName, setClickedName] = useState("");

  const location = useLocation();

  return (
    <div
      role="none"
      className={`sidebar  ${sidebarState ? "close" : "open"}  bg-[#EDF8F9]`}
      onClick={profileDropdownClose}
    >
      <div className="sidebar-logo" style={{ paddingTop: "3px" }}>
        {sidebarState === false ? (
          <div className="w-full flex justify-between items-center">
            <div className="w-[400px]">
            <img
              src={Max_Logo}
              alt="sidebar-logo"
              className="col-span-3 pl-[3.5rem]"
              width={150}
            />
            </div>
              <div className="">
                <img
                    src={MinimizerIcon}
                    className={` col-span-1 justify-end cursor-pointer w-[42px] h-[42px]
                      ${sidebarState ? "transform rotate-180": ""}`
                    }
                    onClick={() => handleSidebarMinimize()}
                    alt="X"
                  />
              </div>
          </div>
        ) : (
          <div className="flex justify-center">
          
              <img
                  src={MinimizerIcon}
                  className={` col-span-1 cursor-pointer
                    ${sidebarState ? "transform rotate-180": "menu-icon"}`
                  }
                  onClick={() => handleSidebarMinimize()}
                  alt="X"
                />
          </div>
        )}
        <hr className={`w-[80%] border-t border-[#CACDCD] `}/>
      </div>
      <ul
        role="none"
        className={`nav-links ${sidebarState ? "" : ""} ${
          scrollActive && sidebarState === false
            ? "scroll-active"
            : "scroll-inactive"
        }`}
        onMouseDown={(e) => handleEvent(e)}
      >
        {Routes.map((item:any) => (
          <>
            {!item?.subMenu ? (
              <li className={`width-inherit${sidebarState ? "" : " pt-[3px] pb-[3px] "}`}>
                <NavLink
                  to={item?.route}
                  className={
                    location.pathname === item?.route || location.pathname.startsWith(item?.route)
                      ? "menu-item active-route"
                      : "menu-item"
                  }
                  onClick={() => {
                    setClickedName(item?.name);
                    handleArrow("none");
                  }}
                >
                  {item?.image ? (
                    <img
                      src={item.image}
                      alt={item.name}
                      className="menu-image"
                    />
                  ) : (
                    item.icon
                  )}
                  <span className="link-name">{item.name ==="Banner"?"Banner Ads":item?.name}</span>
                </NavLink>
                <ul
                  className={
                    sidebarState
                      ? "submenu minimized blank p-0 z-[99]"
                      : "submenu blank p-0 z-[99]"
                  }
                >
                  <li   className={
                    location.pathname === item?.route
                      ? "active-color"
                      : ""
                  } >
                    <NavLink
                      to={item?.route}
                      className="link-name menu-item"
                      onClick={() => setClickedName(item?.name)}
                    >
                      {item.name ==="Banner"?"Banner Ads":item?.name}
                    </NavLink>
                  </li>
                </ul>
              </li>
            ) : (
              <li
                className={` pt-[3px] pb-[3px] ${sidebarState ? "inminimize" : "inmaximize"}  ${
                  arrow?.[item.name]
                    ? ` ${
                      childerenActive ? "showMenu parentSubmenu" : "showMenu "
                    } `
                    : `${childerenActive ? "parentSubmenu " : "width-inherit"} `
                }`}
              >
                <div
                  role="none"
                  className={`iocn-links ${
                    item?.subMenu?.some((e:any) => e.route === location.pathname ||
                     e.route.startsWith(location.pathname))
                      ? "active-route"
                      : ""
                  }`}
                  onClick={() => handleArrow(item.name)}
                >
                  <NavLink
                    to="#"
                    className={
                      location.pathname === item?.route ||
                       location.pathname.startsWith(item?.route)
                        ? "menu-item active-route"
                        : "menu-item"
                    }
                    onClick={() => setClickedName(item?.name)}
                  >
                    {item?.image ? (
                      <img
                        src={item.image}
                        alt={item.name}
                        className="menu-image"
                      />
                    ) : (
                      item.icon
                    )}
                    {
                      !sidebarState &&
                      <div className="flex justify-between items-center w-full">
                        <span className="link-name">{item.name}</span>
                          <SlArrowDown size={15} className={`font-bold text-[15px] ${arrow?.[item.name] ? "rotate-0" : "rotate-90"}`} />
                      </div>
                    }
                    {!sidebarState
                      ? item.subMenu &&
                        clickedName === item?.name &&
                        arrow[clickedName]
                        ? item?.iconOpened
                        : item?.iconClosed
                      : null}
                  </NavLink>
                </div>
                <ul
                  className={
                    sidebarState ? "submenu minimized p-0" : "submenu p-0"
                  }
                >
                  <li className={`hover-class ${
                    item?.subMenu?.some((e:any) => e.route === location.pathname)
                      ? "active-color"
                      : ""
                  }`}>
                    <NavLink
                      to="#"
                      className="link-name menu-item"
                      onClick={() => setClickedName(item?.name)}
                    >
                      {item.name}
                    </NavLink>
                  </li>
                  {item?.subMenu?.map((subMenuItem: any, subMenuItemIndex:number) => (
                    <>
                      <li
                        key={subMenuItemIndex}
                        role="none"
                        className="d-flex justify-content-center sub-menu-height"
                        onMouseEnter={() => setChilderenActive(true)}
                        onMouseLeave={() => setChilderenActive(false)}
                      >
                        <NavLink
                          to={subMenuItem?.route}
                          className={
                            location.pathname === subMenuItem?.route
                              ? "menu-item "
                              : "menu-item"
                          }
                        >
                          <span
                            className={`${
                              sidebarState
                                ? "link-name-submenu minimized"
                                : "link-name-submenu "
                            } ${
                              location.pathname === subMenuItem?.route ||
                               location.pathname.startsWith(subMenuItem?.route)
                                ? "active-route sub-menu-active"
                                : ""
                            }`}
                          >
                            {subMenuItem.name}
                          </span>
                        </NavLink>
                      </li>
                      {subMenuItemIndex !== item?.subMenu?.length - 1 && <hr className={` ms-[2.5rem] me-[1rem] border-t border-[#cacdcd4a] `}/>}
                    </>
                  ))}
                </ul>
              </li>
            )}
          </>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;